<template>
    <b-row class="mt-1" v-if="modifierGroupData.filter(modifier => { return filterModifier(modifier.id)[0].attributes.enabled }).length">
        <b-col md="11" class="offset-md-1 add-ons-container" :style="addOnsWrapperStyle">
            <div class="add-ons-wrapper">
                <label>{{modifierGroup.attributes.name}}</label>
                <small class="text-danger d-block" v-if="this.modifierGroup.attributes.minimum > 0">
                    <span v-html="eyeIcon" class="font-weight-bold d-none"></span>{{ this.modifierGroup.attributes.minimum === 1 ? errorMsg.replace('items', 'item') : errorMsg }}
                </small>
                <ComponentModifier                    
                    ref="modifier"
                    :modifier="filterModifier(modifier.id)[0]"
                    :index="index"
                    v-for="(modifier, index) in modifierGroupData.filter(modifier => { return filterModifier(modifier.id)[0].attributes.enabled })"
                    :key="index"
                ></ComponentModifier>                
            </div>
        </b-col>
    </b-row>
</template>
<script>
import ComponentModifier from "./ComponentModifier";
import SizeModifier from "./SizeModifier";
import { TranslationMixin } from '@/mixins'
export default {
    props: ["modifierGroup"],
    data() {
        return {
            modifierGroupData: [
                ...this.getComponents(),
                ...this.getModifiers()
            ],
            showError: 0,
            freeModifierCount: 0,
            eyeIcon: '<i class="fa fa-exclamation" aria-hidden="true"></i> ',
            errorMsg: this.translation('select_modifier_msg', 'Please select up to MINIMUM_QTY items').replace('MINIMUM_QTY', this.modifierGroup.attributes.minimum)
        };
    },
    components: { ComponentModifier, SizeModifier },
    computed: {
        addOnsWrapperStyle() {
            return {
                "--main-color": this.hexToRgbA(this.$root.mainColor)
            };
        }
    },
    mixins: [TranslationMixin],
    mounted()
    { 
        console.log(this.modifierGroupData)
    },
    methods: {
        getComponents()
        {
            if(this.modifierGroup.relationships.hasOwnProperty('comboItems'))
            {
                return this.modifierGroup.relationships.comboItems.data.filter(modifier => {
                    return this.filterModifier(modifier.id)[0].attributes.name != 'dummy-for-sync' && this.filterModifier(modifier.id)[0].attributes.sizes.length
                }).sort((a, b) => {                
                    return this.filterModifier(a.id)[0].attributes['display-order'] - this.filterModifier(b.id)[0].attributes['display-order']
                })
            }          
            return []  
        },
        getModifiers()
        {
            if(this.modifierGroup.relationships.hasOwnProperty('modifiers'))
            {
                return this.modifierGroup.relationships.modifiers.data.sort((a, b) => {                
                    return this.filterModifier(a.id)[0].attributes['display-order'] - this.filterModifier(b.id)[0].attributes['display-order']
                })
            }
            return []            
        },
        hexToRgbA(hex) {
            var c;
            if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
                c = hex.substring(1).split("");
                if (c.length == 3) {
                    c = [c[0], c[0], c[1], c[1], c[2], c[2]];
                }
                c = "0x" + c.join("");
                return (
                    "rgba(" +
                    [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
                    ",0.23)"
                );
            }
            console.error('Bad hex')
        },
        filterModifier(id) {
            return this.$parent.modifiers.included.filter(data => {
                return data.id === id;
            });
        }
    }
}
</script>